import { Modal, Progress } from "antd";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { setModalVisibility } from "../../../core/app/setModalVisibility/actions";
import { ModalType } from "../../../core/models/custom/enums/modalType";
import { ModalVisibilityPayload } from "../../../core/models/custom/modalVisibility.payload";
import { PaymentSuccessHRTD } from "../../../core/models/custom/paymentSuccessHRTD";
import { MeDto } from "../../../core/models/dtos/me.dto";
import { OfferType } from "../../../core/models/enums/offerType";
import { ApplyOfferState } from "../../../core/services/userService/applyOffer/types";
import { Constants } from "../../../core/utilities/constants";
import ContentKeys from "../../../core/utilities/contentKeys";
import { Helpers } from "../../../core/utilities/helpers";
import { withRouter, WithRouterProps } from "../../../core/utilities/hooks";
import { Images } from "../../../core/utilities/images";
import { IStore } from "../../../core/utilities/reducers";
import { router } from "../../../core/utilities/router";
import { UI } from "../../../core/utilities/ui";
import ContentKey from "../../ContentKey/ContentKey";
import ModalHeader from "../Common/ModalHeader/ModalHeader";
import "./PaymentSuccessModal.scss";

interface IProps {
  secondsLeftInitial: number;
  me?: MeDto;
  modalVisibilityData: ModalType[];
  applyOfferState: ApplyOfferState;
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
  callback: (me: MeDto) => void;
}

interface IState {
  intervalId?: number;
  secondsLeft: number;
}

class PaymentSuccessModal extends React.Component<WithRouterProps<IProps>> {
  state: IState = {
    intervalId: undefined,
    secondsLeft: this.props.secondsLeftInitial,
  };
  private readonly modal = ModalType.PAYMENT_SUCCESS;

  componentDidMount() {
    this.startTimer();
    if (
      !Helpers.isEnvProd() &&
      this.props.applyOfferState.data?.payment.offerType
    ) {
      console.log(">> PaymentSuccessful");
      console.log(
        `offerType: ${this.props.applyOfferState.data.payment.offerType}, level: ${this.props.applyOfferState.data.payment.userLevel}`
      );
      console.log(
        ContentKeys.getPaymentSuccessHRTD(
          this.props.applyOfferState.data.payment.offerType,
          this.props.applyOfferState.data.payment.userLevel
        )
      );
    }
  }

  private getPaymentSuccessHRTD(): PaymentSuccessHRTD {
    if (!this.props.applyOfferState.data?.payment.offerType) {
      alert("offerType not defined after success payment");
      return { header: "", reward: "", title: "", description: "" };
    }
    return ContentKeys.getPaymentSuccessHRTD(
      this.props.applyOfferState.data?.payment.offerType,
      this.props.applyOfferState.data?.payment.userLevel
    );
  }

  private tick(): void {
    const secondsLeft = this.state.secondsLeft - 1;
    this.setState({ secondsLeft });
    if (secondsLeft <= 0) {
      this.handleModal();
      this.clearInterval();
    }
  }

  private startTimer(): void {
    const intervalId = setInterval(() => this.tick(), 1000);
    this.setState({ intervalId });
  }

  private handleModal(): void {
    this.props.setModalVisibility({ modal: this.modal, isVisible: false });
    if (!this.props.me) {
      alert("me not defined at question countdown!");
      this.props.navigate(router.HOME);
      return;
    }
    this.props.callback(this.props.me);
  }

  private clearInterval(): void {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  render() {
    return (
      <Modal
        className="payment-success-modal"
        maskStyle={UI.modalMaskStyle()}
        open
        closable={false}
        footer={false}
        centered
        destroyOnClose
      >
        <ModalHeader
          className="payment-success-modal"
          text={<ContentKey contentKey={this.getPaymentSuccessHRTD().header} />}
          icon={
            <img
              className="icon"
              src={Images.popup_header_icon_check}
              alt="icon"
            />
          }
        />

        <div className="body">
          {this.props.applyOfferState.data?.payment.offerType !==
            OfferType.CONTINUE && (
            <ContentKey
              className="title link-medium"
              contentKey={this.getPaymentSuccessHRTD().title}
            />
          )}

          <ContentKey
            className="text text-medium"
            contentKey={this.getPaymentSuccessHRTD().description}
          />

          <div className="progress-wrapper">
            {
              // 0 will not visible
              this.state.secondsLeft && (
                <Progress
                  type="circle"
                  size="small"
                  percent={
                    (100 * this.state.secondsLeft) /
                    Constants.paymentSuccessDurationInSeconds
                  }
                  format={(left) => {
                    if (!left) return "";
                    return left < 100
                      ? `${this.state.secondsLeft}`
                      : Constants.paymentSuccessDurationInSeconds;
                  }}
                  gapPosition="top"
                  strokeColor="white"
                />
              )
            }
          </div>
        </div>
      </Modal>
    );
  }

  componentWillUnmount() {
    this.clearInterval();
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    modalVisibilityData: store.setModalVisibility.data,
    applyOfferState: store.applyOffer,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<IProps>(PaymentSuccessModal));
